import _get from 'lodash/get';

import { Google, GoogleTransformers } from 'reaxl-analytics-handlers';

import { getInventoryOwnerById } from '@/analytics/utilities';

const { inventoryTransformer: googleInventoryTransformer } = GoogleTransformers;
/**
 * @summary Sends Pixall, Google, Adobe events for navigation bar on VDP
 * @events cmp
 */
export async function inventoryVdpPaginationClick(metadata, option) {

    const {
        data = {},
        state,
        dataLayer = {},
    } = metadata;

    const { type, inventoryId } = data;
    const inventory = getInventoryOwnerById(state, inventoryId);
    const currentPageName = _get(state, 'currentPageName', '');
    const inheritPageData = !['vdp'].includes(currentPageName);
    const listingType = _get(inventory, 'listingType', '').toLowerCase();
    const vehicleData = googleInventoryTransformer(inventory, { target: 'vehicle', dataLayer }, inheritPageData);
    const isPrivateSeller = inventory?.owner?.privateSeller;
    const eventElement = isPrivateSeller ? 'private-seller' : `${currentPageName}_${listingType}`;
    const eventResult = `cta::${currentPageName}::${type}`;

    Google.sendClickEvent({
        eventElement,
        eventResult,
        eventData: {
            vehicle: vehicleData,
        },
    }, option);

    return { eventElement, eventResult };
}
